import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './ProcessStory.css';

// Import local assets
import img1 from '../assets/img1.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';

const ProcessStory = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const x1 = useTransform(scrollYProgress, [0, 0.5], [-100, 0]);
  const x2 = useTransform(scrollYProgress, [0.3, 0.8], [100, 0]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  const steps = [
    {
      id: 1,
      title: "Handpicked from Origin",
      desc: "We travel to the heart of Rajasthan and Kerala to source only the most vibrant, sun-dried crops.",
      img: img1,
      icon: "🌱"
    },
    {
      id: 2,
      title: "The Art of Stone-Grinding",
      desc: "No high-heat machines. We use traditional stone grinders (Khal-Batta) to keep the essential oils intact.",
      img: img2,
      icon: "🗿"
    },
    {
      id: 3,
      title: "Hand-Blended Perfection",
      desc: "Our master blenders follow 50-year-old family recipes to create the perfect aromatic balance.",
      img: img3,
      icon: "✨"
    }
  ];

  return (
    <section className="process-story" ref={containerRef}>
      <div className="container">
        <motion.div 
          className="section-header text-center"
          style={{ opacity }}
        >
          <span className="section-tag">Our Craft</span>
          <h2 className="section-title">The <span className="gradient-text">Journey</span> of Purity</h2>
          <p className="section-sub">From the earth to your hearth — witnessed the meticulous craft behind every gram.</p>
        </motion.div>

        <div className="process-steps">
          {steps.map((step, i) => (
            <div key={step.id} className={`process-step ${i % 2 !== 0 ? 'reverse' : ''}`}>
              <motion.div 
                className="step-image-container"
                style={{ x: i % 2 === 0 ? x1 : x2 }}
              >
                <div className="step-image-wrap">
                  <img src={step.img} alt={step.title} />
                  <div className="step-number">{step.id}</div>
                </div>
                {/* Floating Decoration */}
                <div className="step-deco" />
              </motion.div>

              <motion.div 
                className="step-content"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <span className="step-icon">{step.icon}</span>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-desc">{step.desc}</p>
                <div className="step-line" />
              </motion.div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Background Parallax Texture */}
      <div className="process-bg-text">AUTHENTIC</div>
    </section>
  );
};

export default ProcessStory;
